<template>
	<div class="container">
		<div class="d-flex flex-column align-items-center text-center">
			<img
				src="/assets/img/abdom-logo.png"
				class="img-fluid mb-4 mx-auto d-block"
				width="200px">
			<template v-if="showSubmitted">
				<template v-if="covidSurvey.is_staying">
					<h1>Great!</h1>
					<p v-if="covidSurvey.type === 'Cleaner'">
						Great, we will let the clients know. Please go ahead and contact clients and arrange the start
						date.
					</p>
					<p v-if="covidSurvey.type === 'Client'">
						An agency cleaner will be in touch shortly to organise the next service.
					</p>
				</template>
				<template v-if="!covidSurvey.is_staying">
					<h1>:(</h1>
					<p v-if="covidSurvey.type === 'Cleaner'">
						Ok, we will contact our clients. We have plenty of work if you change your mind!
					</p>
					<p v-if="covidSurvey.type === 'Client'">
						We're sad to see you go. Hopefully we'll see you again soon.
					</p>
				</template>
			</template>
			<template v-if="!showSubmitted && !error">
				<h1 v-if="covidSurvey.type === 'Cleaner'">
					Are you still with us?
				</h1>
				<h1 v-if="covidSurvey.type === 'Client'">
					Would you like to continue your service?
				</h1>
				<p v-if="covidSurvey.type === 'Cleaner'">
					We are restarting our services that have been on hold due to lockdown. <br>

					According to the State Government, those who are vaccinated can get back to work.<br>

					Will you be continuing work with Absolute Domestics?
				</p>
				<p v-if="covidSurvey.type === 'Client'">
					We're open for business and ready to get your home clean and tidy again! Would you like to continue
					your service?
				</p>
				<div class="d-flex flex-row">
					<BButton variant="primary" size="lg"
						@click="submitResponse(1)">
						Yes
					</BButton>
					<BButton variant="secondary" size="lg"
						class="ml-3"
						@click="submitResponse(0)">
						No
					</BButton>
				</div>
				<p v-if="covidSurvey.type === 'Cleaner'" class="mt-3"
					style="font-size: 12px;">
					*If you have been working throughout the lockdown, please just click 'Yes'.
				</p>
			</template>

			<BAlert variant="danger" :model-value="!!error">
				{{ error }}
			</BAlert>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CovidSurvey',
		props: {
			token: {
				type: String,
				required: true,
			}
		},
		data() {
			return {
				covidSurvey: null,
				error: null,
				showSubmitted: false,
			}
		},
		mounted() {
			this.fetchSurvey();
		},
		methods: {
			fetchSurvey() {
				this.$axios.get(`/api/covid-surveys/${this.token}`).then(response => {
					this.covidSurvey = response.data;
				}).catch(error => {
					if (error.response.status === 400) {
						this.error = error.response.data.message;
					} else {
						this.error = 'An unexpected error occurred, please phone Absolute Domestics'
					}
				})
			},
			submitResponse(value) {
				this.$axios.put(`/api/covid-surveys/${this.token}`, {
					is_staying: value,
				}).then(() => {
					this.covidSurvey.is_staying = value;
					this.showSubmitted = true;
				}).catch(error => {
					if (error.response.status === 400) {
						this.error = error.response.data.message;
					} else {
						this.error = 'An unexpected error occurred, please phone Absolute Domestics'
					}
				})
			}
		}
	}
</script>

<style scoped>

</style>
